import { render, staticRenderFns } from "./multi-lang.vue?vue&type=template&id=bb6aaf24"
import script from "./multi-lang.vue?vue&type=script&lang=js"
export * from "./multi-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports